import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { useModulePathResolver } from "capitalrx-shell";
import { useAlert } from "capitalrx-components-2.0/lib/general";

interface SuccessHandlerOptions {
  message?: string;
  invalidations?: string[];
  redirect?: string;
}

export function useSuccessHandler() {
  const showAlert = useAlert();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const resolvePath = useModulePathResolver();

  return useCallback(
    async (options: SuccessHandlerOptions) => {
      const { message, invalidations, redirect } = options;

      if (invalidations) {
        for (const invalidationTarget of invalidations) {
          await queryClient.invalidateQueries({ queryKey: [invalidationTarget] });
        }
      }

      if (redirect !== undefined && redirect !== null) {
        navigate(resolvePath(redirect), {
          state: {
            alert: {
              message,
              type: "success",
              style: "banner",
            },
          },
        });
      } else {
        // if there's a message show the alert
        message
          && showAlert({
            message,
            type: "success",
            style: "toast",
          });
      }
    },
    [navigate, queryClient, resolvePath, showAlert],
  );
}
